module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/fonts/plantin_regular-5c2bbc04b9ecd2439b533f88c453961c.woff2";